import { secondAxios } from "../../../../../api/axios";

/**
 * Every task in the plant (GET /task/all/plant/:plantId - the same endpoint
 * the Task List and MIS module use). Plant-wide, like MRQs: matchSwitchTasks
 * (switchLink.js) filters down to the ones that name one of this vessel's
 * WBS codes.
 */
export const fetchPlantTasks = async (plantId) => {
  const { data } = await secondAxios.get(`/task/all/plant/${plantId}`);
  return Array.isArray(data) ? data : [];
};
